import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailedHeader from '../components/ProjectDetailedPageComponents/DetailedHeader';
import Testimonial from '../components/Testimonial/Testimonial';
import ImageSlider from '../components/Misc/ImageSlider';
import CallToAction from '../components/Misc/CallToAction';
import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';
import { fetchAllImpactStories } from '../Data/ProjectsData';

function ProjectDetailed() {
    const { slug } = useParams();
    const [story, setStory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadImpactStory = async () => {
            try {
                setLoading(true);
                const stories = await fetchAllImpactStories();
                
                if (!stories || stories.length === 0) {
                    setError('No impact stories found');
                    setLoading(false);
                    return;
                }

                // Find the story by slug
                const foundStory = stories.find(s => s.slug === slug);

                if (!foundStory) {
                    setError('Impact story not found');
                    setLoading(false);
                    return;
                }

                setStory(foundStory);
                setLoading(false);
            } catch (err) {
                console.error('Error loading impact story:', err);
                setError('Failed to load impact story');
                setLoading(false);
            }
        };

        loadImpactStory();
    }, [slug]);

    if (loading) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading impact story...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !story) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center py-5">
                        <h2>Error</h2>
                        <p>{error || 'Impact story not found'}</p>
                        <a href="/impact" className="btn btn-primary">Back to Impact Stories</a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <DetailedHeader
                heading={story.heading}
                client={null}
                service={null}
                date={story.date}
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                images={[
                    {
                        image: story.image,
                        alt: story.alt,
                    },
                ]}
            />
            <div className="container mt-5 mb-5">
                <h2 className="heading heading-medium dark-1">{story.heading}</h2>
                <div className="paragraph dark-1">
                    {story.content ? (
                        <div dangerouslySetInnerHTML={{ __html: story.content }} />
                    ) : (
                        <p>{story.description}</p>
                    )}
                </div>
            </div>
            <Testimonial noArt={true} />
            
            {/* CTAs before footer - start */}
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Love to join us? 
                        <br />
                        Volunteer with us now
                    </>
                }
                buttonText="Volunteer Now"
                buttonLink="/get-involved"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
            {/* CTAs before footer - end */}
        </>
    );
}

export default ProjectDetailed;
